import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { faqData } from '../data/mockData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = () => {
  const navigate = useNavigate();

  return (
    <section id="faq" className="relative py-20 bg-[#06070d]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-white/5 px-4 py-2 rounded-lg border border-white/10 mb-6">
            <span className="text-[#f2e2a6] text-sm font-mono uppercase tracking-wider">Knowledge Base // FAQ</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Execution Strategy & <span className="text-[#f2e2a6]">Risks</span>
          </h2>
        </div>

        {/* FAQ Accordion */}
        <div className="bg-gradient-to-br from-white/5 to-white/0 backdrop-blur-xl border border-white/10 rounded-2xl overflow-hidden">
          <Accordion type="single" collapsible className="w-full">
            {faqData.map((faq, index) => (
              <AccordionItem key={faq.id} value={`item-${faq.id}`} className="border-b border-white/10 last:border-0">
                <AccordionTrigger className="px-8 py-6 text-left hover:no-underline hover:bg-white/5 transition-colors">
                  <span className="text-white font-semibold text-lg pr-4">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="px-8 pb-6">
                  <p className="text-gray-400 leading-relaxed">{faq.answer}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <h3 className="text-2xl font-bold text-white mb-4">Ready to trade the spread?</h3>
          <p className="text-gray-400 mb-6">Join the only terminal that scans Polymarket, Kalshi, and Opinion simultaneously.</p>
          <div className="flex justify-center space-x-4">
            <button 
              onClick={() => navigate('/terminal')}
              className="bg-[#f2e2a6] text-black hover:bg-[#f2e2a6]/90 font-semibold px-8 py-4 rounded-lg transition-all hover:scale-105"
            >
              Launch Terminal
            </button>
            <button 
              onClick={() => navigate('/pricing')}
              className="border border-white/20 text-white hover:bg-white/5 font-semibold px-8 py-4 rounded-lg transition-all"
            >
              View Pricing
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
